const normalize = (path) => path.replace(/\/+$/, '').toLowerCase();

const config = () => {
  try {
    return JSON.parse(document.getElementById('qdz-policy-paths')?.textContent || '{}');
  } catch {
    return {};
  }
};

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('a[href]');
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin || url.hash) return;
  const path = normalize(url.pathname);
  const match = Object.entries(config()).find(([, paths]) => paths.filter(Boolean).map(normalize).includes(path));
  const dialog = match && document.getElementById(match[0]);
  if (!dialog || typeof dialog.open !== 'function') return;
  event.preventDefault();
  dialog.open(link);
});
